import React, { useEffect, useState } from "react";
import { PieChart } from "./PieChart";

const COLOURS = [
  "#00B871", "#f95d6a", "#003f5c", "#ff7c43", "#665191",
  "#ffa600", "#9FAFB7", "#d45087", "#2f4b7c", "#a05195",
];

const getColor = (index) => COLOURS[index] || getRandomColor();

const getRandomColor = () => {
  let letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const PreferredProgrammeSpendReportCharts = ({ report }) => {
  const [costSavingsData, setCostSavingsData] = useState([]);
  const [marketShareData, setMarketShareData] = useState([]);

  useEffect(() => {
    if (!report?.preferredProgramme || !report?.notInPreferredProgramme) return;

    const chartSources = [
      { name: "Preferred Programme", data: report.preferredProgramme.totals },
      { name: "Not in Preferred Programme", data: report.notInPreferredProgramme.totals },
    ];

    const costSavings = chartSources.map((entry, index) => ({
      name: entry.name,
      value: parseFloat(Number(entry.data.costSavings || 0).toFixed(0)),
      color: getColor(index),
      currency: "£",
    }));

    const marketShare = chartSources.map((entry, index) => ({
      name: entry.name,
      value: parseFloat(Number(entry.data.marketShare?.overall || 0).toFixed(1)),
      color: getColor(index),
    }));

    setCostSavingsData(costSavings);
    setMarketShareData(marketShare);
  }, [report]);

  return (
    <div className="flex flex-col lg:flex-row max-w-full pt-2 pb-8">
      {costSavingsData.length > 0 && (
        <div className="col-w-full lg:col-w-1/2 text-center">
          <h2>Net Cost Savings £</h2>
          <PieChart data={costSavingsData} />
        </div>
      )}
      {marketShareData.length > 0 && (
        <div className="col-w-full lg:col-w-1/2 text-center">
          <h2>Spend Ratio %</h2>
          <PieChart data={marketShareData} />
        </div>
      )}
    </div>
  );
};

export default PreferredProgrammeSpendReportCharts;
